import {Component, OnInit} from "@angular/core";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {DxPageHeaderOptions} from "../../../../dx-page-markup/domain/ui-options/page-header/dx-page-header-options";

@Component({
  selector: 'pit-error-page',
  templateUrl: './pit-error-page.component.html',
  styleUrls: ['./pit-error-page.component.css']
})
export class PitErrorPageComponent implements OnInit {
  private _headerOptions: DxPageHeaderOptions;

  constructor(private _configService: BdpkConfigService) {}

  ngOnInit(): void {
    this._headerOptions = this._configService.bdpkErrorPageHeaderOptions;
  }

  get headerOptions(): DxPageHeaderOptions {
    return this._headerOptions;
  }
}
